import React, { useEffect } from 'react';
import { useHomePageContentStore } from 'src/hooks/HomePageContent';
import System from "../../../helper/system";
import { HomePageContentTabs } from '../HomePageContentTabs';

let c = System.getParams();

const ProductTabContent = () => {
    const [{ contentTabCount }, { get_content_tab_count }] = useHomePageContentStore();

    // useEffect(() => {
    //     const getList = async () => {
    //         await get_content_tab_count(c.search);
    //     };
    //     getList();
    // }, []);

    return (
        <>
            <div className="filter-records">
                <span>Showing {contentTabCount?.all || 0} content results for <b>"{c.search}"</b></span></div>
            <div className="container-fluid maxw-auto">
                <HomePageContentTabs />
            </div>
        </>
    )
}

export default ProductTabContent